import { computed, Injectable, signal } from '@angular/core'
import {
    SmartQuoteFilter,
    SmartQuoteStatusFilter,
} from 'src/app/shared/interfaces/smartquote/smart-quote-filter.interface'
import { startOfMonth, subMonths } from 'date-fns'

@Injectable({
    providedIn: 'root',
})
export class SmartquoteHelperService {
    #filter = signal<SmartQuoteFilter>({
        pageNumber: 1,
        pageSize: 20,
        dateRangeFilter: {
            from: startOfMonth(subMonths(new Date(), 1)).toISOString(),
            to: new Date().toISOString(),
        },
        status: SmartQuoteStatusFilter.All,
    })

    filter = computed(() => this.#filter())

    updateFilter(filter: SmartQuoteFilter): void {
        this.#filter.set(filter)
    }
}
